import React from 'react';
import dateUtility from 'common/DateUtility';

import {
    InvoiceRow,
    HorizontalDivider,
    ThankYouSection,   
    InvoiceChargeEntry,
    ServiceNotesSection,
    PetroffHeader
} from './InvoiceCommon';

const localStyles = {
    chargeEntry: {
        paddingTop: "10px",
        width: "400px",
        display: "inline-block"
    },
    invoiceHeader: {
        display: "block",
        marginLeft: "30px",
        fontSize: "18px",
        paddingTop: "20px"
    },
};

export default function LoadInvoice(props) {    
    const { customer, commonStyles, invoice, petroffImageSrc} = props;
    const styles = { ...commonStyles, ...localStyles};
    
    const summarySection = () => {                
        const date = invoice.date ? dateUtility.dateToString(invoice.date,'M/D/YYYY') : "";        
        const invoiceNumber = invoice.id ? `L${invoice.id}` : "DRAFT";
        return  (
            <div id={'summary-section-container'} styles={styles.summarySectionContainer}>
                <HorizontalDivider/>
                <InvoiceRow leftText={'Customer'} leftEntry={customer.name} rightText={'Invoice #'} rightEntry={invoiceNumber} id={'invoiceId'}/>
                <InvoiceRow leftText={'Address'} leftEntry={customer.street}/>
                <InvoiceRow leftText={'City'} leftEntry={customer.city} rightText={'Date'} rightEntry={date} id={'date'}/>
                <InvoiceRow leftText={'State'} leftEntry={customer.state} rightText={'Unit #'} rightEntry={invoice.unit}/>
                <InvoiceRow leftText={'Zip'} leftEntry={customer.zipcode} rightText={'Load #'} rightEntry={invoice.loadNumber}/>
                <InvoiceRow leftText={'Phone'} leftEntry={customer.phone} rightText={'Company PO #'} rightEntry={invoice.companyPO}/>
                <InvoiceRow leftText={'Location'} leftEntry={invoice.location} rightText={'Reference #'} rightEntry={invoice.referenceNumber}/>                
                <InvoiceRow leftText={'Contents'} leftEntry={invoice.contents}/>
                <HorizontalDivider/>
            </div> 
        )
    }

    const TowInvoiceChargeEntry = ({text,entry}) => {        
        return (            
            <InvoiceChargeEntry text={text} entry={entry} entryStyle={styles.chargeEntry}/>
        )
    }

    const invoiceChargeNonMonetaryEntry = (text,entry) => {
        const entryId = text.split(' ').join('-').toLowerCase();
        return (            
            <div style={styles.chargeEntry}>
                <div style={styles.chargeEntryName}>{text}:</div><div id={entryId} style={styles.entryChargeText}>{entry}</div>
            </div>
        )
    }

    const chargesSection = () => {        
        const paymentDate = invoice.paymentDate ? dateUtility.dateToString(invoice.paymentDate,'M/D/YYYY') : ""; 
        
        return (
            <div style={styles.chargesSection}>                
                <TowInvoiceChargeEntry text={'Dock Fees'} entry={invoice.dockFees}/>                
                <TowInvoiceChargeEntry text={'Time Charges'} entry={invoice.timeCharges}/>
                <TowInvoiceChargeEntry text={'Additional Charges'} entry={invoice.additionalCharges}/>
                <TowInvoiceChargeEntry text={'Credits'} entry={invoice.credits}/>
                <TowInvoiceChargeEntry text={'Posted To Receivables'} entry={invoice.postedToReceivables}/>
                {invoiceChargeNonMonetaryEntry('Payment Date',paymentDate)}
                <TowInvoiceChargeEntry text={'Invoice Total'} entry={invoice.invoiceTotal}/>                             
            </div>
        )
    }

    return (
        <div id="capture" style={styles.page}>
            {PetroffHeader(petroffImageSrc)}
            {summarySection()}
            <ServiceNotesSection serviceNotes={invoice.serviceNotes}/>
            <HorizontalDivider/>
            {chargesSection()}
            <ThankYouSection/>
        </div>    
    );
}



